import "./DentalMyths.module.css";
import Header from "@/reusable_sections/Header";
import SeparatingFactFromFiction from "./sections/SeparatingFactFromFiction";
import SubmitAMyth from "./sections/SubmitAMyth";
import Footer from "@/reusable_sections/Footer";
export default function DentalMythsPage() {
  return <div>
      <Header />
      <SeparatingFactFromFiction />
      <SubmitAMyth />
      <Footer />
    </div>;
}